const industry_US_Locale = {
    'industry.title': 'The Preferred Choice of Leading Industry Institutions and Enterprises'
}
export default industry_US_Locale
